import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';

import './PriceFilter.less';
import Slider from '../Slider/Slider';
import PriceInputs from '../PriceInputs/PriceInputs';
import {
    getLimitedMaxPrice,
    getLimitedMaxDisplayPrice,
} from '../../utils/priceUtils';

export type BoundsType = Array<number | null>;
type Props = {
    currency: string;
    hasDates: boolean;
    minPrice: number | null;
    maxPrice: number | null;
    onPriceChange: (BoundsType) => void;
    className: string;
    priceInputValuesAreValid: boolean;
    updatePriceInputValuesValidity: Function;
};
type State = {
    activeHandleIndex: number | null;
};

export const nullIfMaxBounds = (
    maxAllowedPrice: number,
    callback: (BoundsType) => any
) => {
    return (bounds: BoundsType) => {
        let newBounds: BoundsType = [];
        if (maxAllowedPrice && bounds[1] && bounds[1] >= maxAllowedPrice) {
            newBounds = [bounds[0], null];
        } else {
            newBounds = newBounds.concat(bounds);
        }
        callback(newBounds);
    };
};

export function PriceFilter(props: Props) {
    const [activeHandleIndex, setActiveHandleIndex] = useState(null);

    const handleSetActiveHandle = (index) => {
        setActiveHandleIndex(index);
    };

    const {currency, onPriceChange, className, maxPrice} = props;
    const limitedMaxPrice = getLimitedMaxPrice(currency);

    const maxAllowedPrice = limitedMaxPrice;

    const maxDisplayPrice = getLimitedMaxDisplayPrice(
        maxAllowedPrice,
        maxPrice
    );
    const minPrice = props.minPrice || 0;
    const isMax = maxDisplayPrice >= maxAllowedPrice;

    const onChange = nullIfMaxBounds(maxAllowedPrice, onPriceChange);

    const classes = classNames(
        `PriceFilter PriceFilter--min-max-price-fields-test-V1`,
        {
            [className]: className,
        }
    );

    return (
        <div
            role="menuitem"
            aria-labelledby={`filter-group-label-${className}`}
            className={classes}
        >
            <span className="sr-only" id={`filter-group-label-${className}`}>
                <FormattedMessage
                    id={'filterBarPriceLabel'}
                    defaultMessage={'Price'}
                />
            </span>
            <div className="PriceFilter__priceLabel">
                <span className="PriceFilter__priceLabel__values">
                    <FormattedMessage
                        id={'pricePerNightLabel'}
                        defaultMessage={'Price per night'}
                    />
                </span>
            </div>

            <div
                className="PriceFilter__PriceInputs"
                data-wdio="PriceFilter__PriceInputs"
            >
                <PriceInputs
                    activeHandleIndex={activeHandleIndex}
                    currency={currency}
                    isMax={isMax}
                    maxAllowedPrice={maxAllowedPrice}
                    maxPrice={maxDisplayPrice}
                    minPrice={minPrice}
                    onChange={onChange}
                    priceInputValuesAreValid={props.priceInputValuesAreValid}
                    updatePriceInputValuesValidity={
                        props.updatePriceInputValuesValidity
                    }
                />
            </div>
            <div
                className="PriceFilter__slider"
                data-wdio="PriceFilter__slider"
            >
                <Slider
                    className={'Slider--min-max-price-fields-test'}
                    start={minPrice}
                    stop={maxDisplayPrice}
                    max={limitedMaxPrice}
                    activeHandleIndex={activeHandleIndex}
                    step={10}
                    onChange={onChange}
                    onSetActiveHandle={handleSetActiveHandle}
                    edapLabel="nightly_price_slider"
                />
            </div>
        </div>
    );
}

export default PriceFilter;
